import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

interface ScannerToolbarProps {
  onLoadSample?: (sample: string) => void;
  onExport?: () => void;
}

const ScannerToolbar: React.FC<ScannerToolbarProps> = ({ onLoadSample, onExport }) => {
  const [sample, setSample] = React.useState('');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
      <Button variant="outlined" startIcon={<UploadFileIcon />} component="label">
        Upload
        <input
          hidden
          accept=".sol"
          type="file"
          onChange={(e) => {
            const f = e.target.files && e.target.files[0];
            if (!f) return;
            const reader = new FileReader();
            reader.onload = () => {
              const txt = String(reader.result || '');
              onLoadSample && onLoadSample(txt);
            };
            reader.readAsText(f);
          }}
        />
      </Button>

      <Button variant="outlined" startIcon={<FileOpenIcon />} onClick={() => onLoadSample && onLoadSample(sample)}>
        Load Sample
      </Button>

      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="sample-select-label">Sample Contracts</InputLabel>
        <Select
          labelId="sample-select-label"
          value={sample}
          label="Sample Contracts"
          onChange={(e) => setSample(String(e.target.value))}
        >
          <MenuItem value="">(paste or upload)</MenuItem>
          <MenuItem value={`// SPDX-License-Identifier: MIT\npragma solidity ^0.8.0;\ncontract Token { mapping(address=>uint) public balance; function mint() public { balance[msg.sender] += 100; } }`}>Simple Token</MenuItem>
          <MenuItem value={`// SPDX-License-Identifier: MIT\npragma solidity ^0.8.0;\ncontract Reentrant { mapping(address=>uint) public balance; function withdraw() public { uint bal = balance[msg.sender]; (bool ok,) = msg.sender.call{value:bal}(''); if(ok) balance[msg.sender]=0; } }`}>Reentrancy Sample</MenuItem>
        </Select>
      </FormControl>

      <Box sx={{ flex: 1 }} />
      <Button 
        variant="contained" 
        color="primary" 
        startIcon={<SaveAltIcon />} 
        onClick={onExport}
        sx={{
          background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
          boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
        }}
      >
        Generate HTML Report
      </Button>
    </Box>
  );
};

export default ScannerToolbar;
